jQuery(document).ready(function ($) {
    //scroll to main content
    $('#skip-link').on('click keydown', function (e) {
        if (
            e.type === 'click' ||
            (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))
        ) {
            if (e.key === ' ') {
                e.preventDefault(); // prevent page scroll
            }

            const target = document.querySelector('main#main');

            if (target) {
                target.setAttribute('tabindex', '-1');
                target.focus();
            }
        }
    });
    // Function to remove js-dropdown-active class when focus moves away from submenu
    function removeActiveClass() {
        $('.js-dropdown-active').removeClass('js-dropdown-active');
    }

    // Event listener to detect focus leaving the submenu
    $('.is-dropdown-submenu').on('focusout', function (event) {
        var isInsideSubmenu = $(this).has(event.relatedTarget).length > 0;
        if (!isInsideSubmenu) {
            removeActiveClass();
        }
    });

    //remove sr text 
    $('.moove-gdpr-modal-close').find('.gdpr-sr-only').remove();
    //
    $('.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet')
        .on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).click();
            }
        });
    //  slders
    let carouselIndex = 0;

    const observer = new MutationObserver(() => {
        $('.cb-carousel-block .swiper.swiper-initialized').each(function () {
            const $swiper = $(this);
            const $carousel = $swiper.closest('.cb-carousel-block');

            if ($carousel.attr('data-a11y-ready')) return;

            carouselIndex++;

            const $wrapper = $carousel.find('.swiper-wrapper');
            const id = 'carousel-' + carouselIndex;

            // Set landmark
            $carousel.attr({
                'role': 'region',
                'aria-roledescription': 'carousel',
                'aria-label': `Carousel ${carouselIndex}`,
                'data-a11y-ready': 'true'
            });

            // Set wrapper ID
            $wrapper.attr('id', id);

            // Link buttons
            $carousel.find('.swiper-button-next, .swiper-button-prev')
                .attr('aria-controls', id);

            // Improve pagination bullets
            $carousel.find('.swiper-pagination-bullet').each(function (i) {
                $(this).attr({
                    'role': 'button',
                    'aria-label': `Go to slide ${i + 1}`
                });
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    //buttons
    setTimeout(function () {
        $('.wp-block-tiptip-hyperlink-group-block span.wp-block-button__link.wp-element-button[tabindex]')
            .removeAttr('tabindex');
    }, 150);
    // Start observing the entire body for child additions
    observer.observe(document.body, { childList: true, subtree: true });

    // Capture the element that opened the modal
    let lastTrigger = null;

    $(document).on('click', '[data-open], .edit-handoff', function () {
        lastTrigger = this;
        // console.log('lastTrigger', lastTrigger);
    });
    // When modal opens, focus close button
    $(document).on('open.zf.reveal', '[data-reveal]', function () {
        var $closeBtn = $(this).find('[data-close]').first();
        if ($closeBtn.length) {
            setTimeout(function () {
                $closeBtn.focus();
            }, 0);
        }
    });
    // When modal closes, return focus
    $(document).on('closed.zf.reveal', '[data-reveal]', function () {
        console.log('i close');
        if (lastTrigger) {
            const $el = $(lastTrigger);

            if ($el.length) {
                $el[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                $el[0].focus({ preventScroll: true });
            }
        } else {
            const $main = $('main#main');

            if ($main.length) {
                $main[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
                $main[0].focus({ preventScroll: true });
            }
        }

    });

    // Add tab index to hamberger nav 
    let $menuOpenButton = $('button.hamburger-container');
    $menuOpenButton.removeAttr('aria-controls aria-expanded');

    let $menuOffCanvas = $('#off-canvas');
    // console.log('$offCanvas', $menuOffCanvas);

    $menuOffCanvas.on('opened.zf.offCanvas', function () {
        // console.log('OPENED fired');
        $menuOpenButton.removeAttr('aria-expanded');
        $menuOffCanvas.attr('tabindex', '0');
    });

    $menuOffCanvas.on('closed.zf.offCanvas', function () {
        // console.log('CLOSED fired');
        $menuOpenButton.removeAttr('aria-expanded');
        $menuOffCanvas.attr('tabindex', '-1');
                $('button.hamburger-container').focus();

    });

    $(document).on('opened.zf.offCanvas', '#off-canvas', function () {
        var $focusable = $(this).find(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');

        var first = $focusable.first();
        var last = $focusable.last();

        first.focus();

        $(document).on('keydown.offcanvasTrap', function (e) {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === first[0]) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (document.activeElement === last[0]) {
                    e.preventDefault();
                    first.focus();
                }
            }
        });
    });

    $(document).on('closed.zf.offCanvas', '#off-canvas', function () {
        $(document).off('keydown.offcanvasTrap');
        $('button.hamburger-container').focus();

    });

});
